export default __webpack_public_path__ + "static/media/certi6.40515b50.png";